import { render, staticRenderFns } from "./FormCheckbox.vue?vue&type=template&id=e2b46fba&scoped=true&"
import script from "./FormCheckbox.ts?vue&type=script&lang=ts&"
export * from "./FormCheckbox.ts?vue&type=script&lang=ts&"
import style0 from "./FormCheckbox.scss?vue&type=style&index=0&id=e2b46fba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2b46fba",
  null
  
)

export default component.exports